import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  selectItemById,
  selectItemsIds,
  sendRequest,
  changeQueryParams,
  selectRequestState,
  selectPagination,
  selectQueryParams,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import RatingPointHistoryItem from './RatingPointHistoryItem';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import PaginationBlock from '../../Common/Pagination/PaginationBlock/PaginationBlock';

import PointsTypeIdSelect from './inputs/PointsTypeIdSelect';
import TypeOperationSelect from '../../../components/Common/Inputs/TypeOperationSelect';
import DateRangeInput from '../../Common/Inputs/DateRangeInput';
import SortLabelColumnToggle from '../../Common/Inputs/SortLabelColumnToggle';

class RatingPointHistoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultQueryParams: {
        page: 1,
        type_operation: null,
        points_type_id: null,
        createdFrom: null,
        createdTo: null,
        sort: '-created_at'
      }
    };
    this.props.changeDefaultQueryParams(this.state.defaultQueryParams);
    this.props.sendRequest();
  }

  render() {
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <RatingPointHistoryItem
              key={`RatingPointHistoryItem${itemId}`}
              pointItem={this.props.selectItemById(itemId)}
            />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <tr>
          <td className="text-center" colSpan="5">
            {t('Записи не найдены')} :-(
          </td>
        </tr>
      );
    }

    return (
      <div>
        {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
        <form className="form-inline">
          <PointsTypeIdSelect
            startValue={parseInt(
              this.props.selectQueryParams.points_type_id,
              10
            )}
            handleChangeValue={value => {
              this.props.changeQueryParams({
                page: 1,
                points_type_id: value
              });
              this.props.sendRequest();
            }}
          />
          <div className="form-group btn-group pull-right">
            <TypeOperationSelect
              startValue={this.props.selectQueryParams.type_operation}
              handleChangeValue={value => {
                this.props.changeQueryParams({
                  page: 1,
                  type_operation: value
                });
                this.props.sendRequest();
              }}
            />
          </div>
          <DateRangeInput
            startValueFrom={this.props.selectQueryParams.createdFrom}
            startValueTo={this.props.selectQueryParams.createdTo}
            idElement={`RatingPointHistoryTable-dataRange`}
            handleChangeRangeValues={range => {
              this.props.changeQueryParams({
                page: 1,
                createdFrom: range.valueFrom,
                createdTo: range.valueTo
              });
              this.props.sendRequest();
            }}
          />
        </form>
        <div className="table-responsive">
          <table className="table table-sortible table-hover m-b-0">
            <thead>
              <tr>
                <SortLabelColumnToggle
                  label={t('Дата')}
                  tag="th"
                  defaultValue="created_at"
                  selectedValue={this.props.selectQueryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.props.changeQueryParams({
                      sort: sortValue
                    });
                    this.props.sendRequest();
                  }}
                />
                <SortLabelColumnToggle
                  label={t('Тип')}
                  tag="th"
                  className="text-center"
                  defaultValue="points"
                  selectedValue={this.props.selectQueryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.props.changeQueryParams({
                      sort: sortValue
                    });
                    this.props.sendRequest();
                  }}
                />
                <SortLabelColumnToggle
                  label={t('Операция')}
                  tag="th"
                  defaultValue="points_type"
                  selectedValue={this.props.selectQueryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.props.changeQueryParams({
                      sort: sortValue
                    });
                    this.props.sendRequest();
                  }}
                />
                <th>{t('Описание')}</th>
                <SortLabelColumnToggle
                  label={t('Баллы')}
                  tag="th"
                  defaultValue="points"
                  selectedValue={this.props.selectQueryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.props.changeQueryParams({
                      sort: sortValue
                    });
                    this.props.sendRequest();
                  }}
                />
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </table>
        </div>
        <div className="table-footer">
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </div>
      </div>
    );
  }
}

RatingPointHistoryTable.contextTypes = {
  router: PropTypes.shape()
};

RatingPointHistoryTable.propTypes = {
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    points_type_id: PropTypes.string,
    type_operation: PropTypes.string,
    createdFrom: PropTypes.string,
    createdTo: PropTypes.string,
    sort: PropTypes.string
  }).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id),
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RatingPointHistoryTable);



// WEBPACK FOOTER //
// ./src/components/Rating/RatingPointHistoryTable/RatingPointHistoryTable.js